// ModalCredencial.jsx - Versión mejorada con selects
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import ImageEditor from './ImageEditor';

const ModalCredencial = ({ isOpen, onClose, onSuccess, credencial }) => {
  const [formData, setFormData] = useState({
    nombres: '',
    apellido_paterno: '',
    apellido_materno: '',
    nombre_completo: '',
    oracle: '',
    razon_social: '',
    registro_patronal: '',
    departamento: '',
    puesto: '',
    localidad: '',
    nss: '',
    acceso: '',
    color: '',
    tipo_empleado: '',
    foto_url: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showImageEditor, setShowImageEditor] = useState(false);
  const [fotoUrlWithTimestamp, setFotoUrlWithTimestamp] = useState('');

  const isGuatemala = (data) => {
    if (!data) return false;
    const localidad = data.localidad || '';
    const acceso = data.acceso || '';
    return localidad === 'LOC_DHL_GUATEMALA' || acceso === 'Almacén Guatemala';
  };

  // Mapeo de Razón Social a Registro Patronal
  const razonSocialToRegistroPatronal = {
    'PACKSYS DISTRIBUCION SA DE CV': 'Y5481093101',
    'DISTRIBUCION Y COMERCIALIZACION DE PRODUCTOS INNOVADORES INNOVA SA DE CV':
      'Z4128710101',
    'PACKSYS MEXICO SA DE CV': 'Y5470092106',
    'DENSEN SA DE CV': 'Y6130184101',
    'THAIBO GRUPO ESTRATEGICO SA DE CV': 'Z3458291104',
    'HALYCON LOGISTICA SA DE CV': 'Y5470137109',
    'REMBEX GRUPO ADMINISTRATIVO SA DE CV': 'Y6483769102',
  };

  // Opciones para los selects
  const razonesSociales = [
    'PACKSYS DISTRIBUCION SA DE CV',
    'DISTRIBUCION Y COMERCIALIZACION DE PRODUCTOS INNOVADORES INNOVA SA DE CV',
    'PACKSYS MEXICO SA DE CV',
    'DENSEN SA DE CV',
    'THAIBO GRUPO ESTRATEGICO SA DE CV',
    'HALYCON LOGISTICA SA DE CV',
    'REMBEX GRUPO ADMINISTRATIVO SA DE CV',
  ];

  const departamentos = [
    'Legal',
    'Mantenimiento',
    'Áreas Comerciales',
    'Atracción de Talento',
    'Finanzas y Administración',
    'Tecnología e Informática',
    'Dirección',
    'Operaciones',
    'Auditoría Interna',
  ];

  const localidades = [
    'LOC_DHL_PUEBLA',
    'LOC_CUAUTIPARK II',
    'LOC_OFNA_TOREO',
    'LOC_DHL CAT',
    'LOC_GDL',
    'LOC_OFNA_MERIDA',
    'LOC_DHL_CD9',
    'LOC_LOGIS_MTY',
    'LOC_MRD',
    'LOC_OFNA_MONTERREY',
    'LOC_CUAUTIPARKII',
    'LOC_DHL_GDL',
    'LOC_DHL_GUATEMALA',
  ];

  const accesos = [
    'Mérida',
    'Acceso General',
    'Torre Albia',
    'Durango',
    'Piso 1 y 5',
    'Arca Torreón',
    'CD9',
    'MTY',
    'CUAUTIPARK II',
    'DHL GDL',
    'GDL',
    'Piso 5',
    'Piso 1',
    'Almacén Puebla',
    'Almacén Guatemala',
  ];

  const colores = ['NARANJA', 'AZUL', 'AQUA', 'CELESTE', 'MORADO', 'VERDE'];

  useEffect(() => {
    if (credencial) {
      setFormData(credencial);
    } else {
      setFormData({
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        nombre_completo: '',
        oracle: '',
        razon_social: '',
        registro_patronal: '',
        departamento: '',
        puesto: '',
        localidad: '',
        nss: '',
        acceso: '',
        color: '',
        tipo_empleado: '',
        foto_url: '',
      });
    }
    setError('');
  }, [credencial]);

  // Prevenir scroll del body cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    if (
      formData.foto_url &&
      formData.foto_url !== 'null' &&
      formData.foto_url !== ''
    ) {
      const timestamp = new Date().getTime();
      setFotoUrlWithTimestamp(`${formData.foto_url}?t=${timestamp}`);
    } else {
      setFotoUrlWithTimestamp('');
    }
  }, [formData.foto_url]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Si cambia la razón social, actualizar automáticamente el registro patronal
    if (name === 'razon_social') {
      const registroPatronal = razonSocialToRegistroPatronal[value] || '';
      setFormData({
        ...formData,
        [name]: value,
        registro_patronal: registroPatronal,
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (credencial) {
        await api.put(`/credenciales/${credencial.id}`, formData);
      } else {
        await api.post('/credenciales', formData);
      }
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar la credencial');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/70 backdrop-blur-md z-[99] flex items-center justify-center p-4"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100vw',
          height: '100vh',
          margin: 0,
          padding: 0,
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <div
          className="bg-gradient-to-br from-gray-900 to-slate-900 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto border border-white/20 animate-modalSlideIn"
          onClick={(e) => e.stopPropagation()}
          style={{ position: 'relative' }}
        >
          {/* Header */}
          <div className="sticky top-0 bg-gradient-to-r from-gray-800/95 via-blue-800/95 to-gray-800/95 backdrop-blur-xl border-b border-white/20 px-6 py-4 flex justify-between items-center z-10 rounded-t-2xl">
            <h3 className="text-xl font-bold text-white">
              {credencial ? 'Editar Credencial' : 'Nueva Credencial'}
            </h3>
            <button
              onClick={onClose}
              className="text-white/60 hover:text-white hover:bg-white/10 rounded-lg p-1 transition-all duration-200"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6">
            {error && (
              <div className="mb-4 p-3 bg-red-500/20 border border-red-500/30 rounded-xl animate-shake">
                <p className="text-red-300 text-sm">{error}</p>
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Campos de nombre */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Nombres *
                </label>
                <input
                  type="text"
                  name="nombres"
                  value={formData.nombres}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Apellido Paterno *
                </label>
                <input
                  type="text"
                  name="apellido_paterno"
                  value={formData.apellido_paterno}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Apellido Materno *
                </label>
                <input
                  type="text"
                  name="apellido_materno"
                  value={formData.apellido_materno}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Nombre Completo (Automático)
                </label>
                <input
                  type="text"
                  value={`${formData.nombres} ${formData.apellido_paterno} ${formData.apellido_materno}`.trim()}
                  disabled
                  className="w-full px-4 py-2 bg-white/5 border border-white/20 rounded-xl text-white/70 cursor-not-allowed"
                />
              </div>

              {/* Razón Social (Select) */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Razón Social
                </label>
                <select
                  name="razon_social"
                  value={formData.razon_social || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                >
                  <option value="" className="bg-gray-800">
                    Seleccionar Razón Social
                  </option>
                  {razonesSociales.map((razon, idx) => (
                    <option key={idx} value={razon} className="bg-gray-800">
                      {razon}
                    </option>
                  ))}
                </select>
              </div>

              {/* Registro Patronal (Automático - Solo lectura) */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  {isGuatemala(formData)
                    ? 'CUI (Automático)'
                    : 'Registro Patronal (Automático)'}
                </label>
                <input
                  type="text"
                  name="registro_patronal"
                  value={
                    isGuatemala(formData)
                      ? '3544196920101'
                      : formData.registro_patronal || ''
                  }
                  disabled
                  className="w-full px-4 py-2 bg-white/5 border border-white/20 rounded-xl text-white/70 cursor-not-allowed"
                />
              </div>

              {/* Departamento (Select) */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Departamento
                </label>
                <select
                  name="departamento"
                  value={formData.departamento || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                >
                  <option value="" className="bg-gray-800">
                    Seleccionar Departamento
                  </option>
                  {departamentos.map((dept, idx) => (
                    <option key={idx} value={dept} className="bg-gray-800">
                      {dept}
                    </option>
                  ))}
                </select>
              </div>

              {/* Puesto (Input) */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Puesto
                </label>
                <input
                  type="text"
                  name="puesto"
                  value={formData.puesto || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                />
              </div>

              {/* Localidad (Select) */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Localidad
                </label>
                <select
                  name="localidad"
                  value={formData.localidad || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                >
                  <option value="" className="bg-gray-800">
                    Seleccionar Localidad
                  </option>
                  {localidades.map((loc, idx) => (
                    <option key={idx} value={loc} className="bg-gray-800">
                      {loc}
                    </option>
                  ))}
                </select>
              </div>

              {/* Oracle */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Oracle
                </label>
                <input
                  type="text"
                  name="oracle"
                  value={formData.oracle || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                />
              </div>

              {/* NSS */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  {isGuatemala(formData) ? 'NIT' : 'NSS'}
                </label>
                <input
                  type="text"
                  name="nss"
                  value={formData.nss || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                />
              </div>

              {/* Acceso (Select) */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Acceso
                </label>
                <select
                  name="acceso"
                  value={formData.acceso || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                >
                  <option value="" className="bg-gray-800">
                    Seleccionar Acceso
                  </option>
                  {accesos.map((acc, idx) => (
                    <option key={idx} value={acc} className="bg-gray-800">
                      {acc}
                    </option>
                  ))}
                </select>
              </div>

              {/* Color (Select) */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Color
                </label>
                <select
                  name="color"
                  value={formData.color || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                >
                  <option value="" className="bg-gray-800">
                    Seleccionar Color
                  </option>
                  {colores.map((color, idx) => (
                    <option key={idx} value={color} className="bg-gray-800">
                      {color}
                    </option>
                  ))}
                </select>
              </div>

              {/* Tipo de Empleado */}
              <div>
                <label className="block text-sm font-medium text-blue-200 mb-1">
                  Tipo de Empleado *
                </label>
                <select
                  name="tipo_empleado"
                  value={formData.tipo_empleado || ''}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-transparent transition-all duration-300"
                >
                  <option value="" className="bg-gray-800">
                    Seleccionar Tipo
                  </option>
                  <option value="ADMINISTRATIVO" className="bg-gray-800">
                    ADMINISTRATIVO
                  </option>
                  <option value="OPERATIVO" className="bg-gray-800">
                    OPERATIVO
                  </option>
                </select>
              </div>

              {/* Foto de perfil */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-blue-200 mb-3">
                  Foto de perfil
                </label>

                <div className="flex items-center space-x-6">
                  <div className="relative group">
                    <div className="w-24 h-24 rounded-full overflow-hidden bg-gradient-to-br from-white/10 to-white/5 border-2 border-white/30 shadow-lg">
                      {fotoUrlWithTimestamp ? (
                        <img
                          src={fotoUrlWithTimestamp}
                          alt="Foto de perfil"
                          className="w-full h-full object-cover"
                          crossOrigin="anonymous"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-white/40">
                          <svg
                            className="w-10 h-10"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1.5"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                        </div>
                      )}
                    </div>

                    <button
                      type="button"
                      onClick={() => setShowImageEditor(true)}
                      className="absolute -bottom-1 -right-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white p-2 rounded-full shadow-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-110"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                        />
                      </svg>
                    </button>
                  </div>

                  <div className="flex-1">
                    <p className="text-sm text-blue-200/80">
                      Haz clic en el ícono ✏️ para editar tu foto
                    </p>
                    <p className="text-xs text-blue-200/50 mt-1">
                      La foto se ajustará automáticamente a un formato cuadrado
                    </p>
                  </div>
                </div>

                <input
                  type="hidden"
                  name="foto_url"
                  value={formData.foto_url || ''}
                />
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-6 pt-4 border-t border-white/20">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-xl transition-all duration-300 border border-white/20"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-50 disabled:hover:scale-100 shadow-lg"
              >
                {loading ? (
                  <span className="flex items-center space-x-2">
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <span>Guardando...</span>
                  </span>
                ) : credencial ? (
                  'Actualizar'
                ) : (
                  'Crear'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {showImageEditor && (
        <ImageEditor
          initialImageUrl={formData.foto_url}
          credencialId={credencial?.id}
          nombres={formData.nombres}
          apellidoPaterno={formData.apellido_paterno}
          apellidoMaterno={formData.apellido_materno}
          tipoEmpleado={formData.tipo_empleado}
          onImageSaved={(newUrl) => {
            setFormData({
              ...formData,
              foto_url: newUrl,
            });
            setShowImageEditor(false);
          }}
          onCancel={() => setShowImageEditor(false)}
        />
      )}

      <style>{`
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
          20%, 40%, 60%, 80% { transform: translateX(2px); }
        }
        .animate-modalSlideIn {
          animation: modalSlideIn 0.3s ease-out;
        }
        .animate-shake {
          animation: shake 0.5s ease-in-out;
        }
      `}</style>
    </>
  );
};

export default ModalCredencial;
